module.exports = __webpack_public_path__ + "static/media/liability.393fc3a3.svg";